import { config } from "@/config";
export class AIService {
    static getHeaders() {
        return {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };
    }
    /**
     * Remueve el fondo de una imagen usando el servidor.
     * @param file Archivo de imagen original.
     * @returns Blob de la imagen procesada (WebP).
     */
    static async removeBackground(file) {
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(`${config.API_URL}/api/Ai/RemoveBackground`, {
            method: "POST",
            headers: this.getHeaders(),
            body: formData,
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || "Error al procesar la imagen con IA");
        }
        return await response.blob();
    }
}
